import React from 'react';
import { RouteChildrenProps } from 'react-router';
import { Redirect } from 'react-router-dom';
import { Col, Container, Row } from 'src/shared/design-system/Layout';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { getLoginRedirect } from 'src/shared/utils/RouteUtilities';
import { Spacing } from 'web-common/src/shared/styles';

export const ConsumerAccount: React.FC<React.PropsWithChildren<Pick<RouteChildrenProps, 'match'>>> = ({
  match,
  children,
}) => {
  // Redirect to login if necessary
  const [currentUser, loading] = useCurrentUser();

  if (!loading && !currentUser) {
    return <Redirect to={getLoginRedirect(match)} />;
  }

  return (
    <Container style={{ marginBottom: Spacing.SINGLE_QUARTER }}>
      <Row>
        <Col md='10'>{loading ? null : children}</Col>
      </Row>
    </Container>
  );
};
